import store from '@/store'

export default {
  mounted(el, binding, vnode) {
    const { value } = binding
    const permissions = store.getters && store.getters['user/userPermission']

    let hasPermission = false
    if (Array.isArray(value)) {
      hasPermission = permissions.some(v => value.includes(v.permissionCode))
    } else {
      hasPermission = permissions.find(v => v.permissionCode === value)
    }
    if (!hasPermission) el.parentNode && el.parentNode.removeChild(el)
  }
}
